
export interface RefundRequest {
  amount: number;
  orderId: string;
  reason?: string;
}
